import {Component, OnInit} from '@angular/core';
import {FieldDefinition} from '@shared/models/field-definition';
import {CellComponent} from '@shared/components/cell-components/cell-component';

@Component({
    standalone: false,
    selector: 'particle-emphasized-cell-viewer',
  templateUrl: './emphasized-cell-viewer.component.html',
  styleUrls: ['./emphasized-cell-viewer.component.scss']
})
export class EmphasizedCellViewerComponent implements OnInit, CellComponent {
  fieldDefinition: FieldDefinition;
  topicsCount: number;
  topics: any;
  item: any;
  showMenu: boolean;

  constructor() {
    this.showMenu = false;
  }

  ngOnInit() {
    this.topics = this.item.cells[this.fieldDefinition.key].value;
  }
}
